import React, { Component } from 'react';
import CustomCountTable from '../../../container/molecules/CustomCountTableContainer';
import IconButton from '../../atoms/IconButton';
import { filterConditionState } from '../../../redux/reducers/CurrentFilterReducer';
import { CustomCountProps } from '../../../redux/reducers/CustomCountListReducer';
import { makeSearchConditionDisplayStr } from '../../../Common';
import { ConditionItem } from '../../../external/Common';
import { GASpotEventState } from '../../organisms/NegotiationCountList';

interface CustomCountHandler {
  filterList: filterConditionState[];
  jobDateTime?: string;
  gaSpotEvent?: GASpotEventState;
}

interface OwnProps extends CustomCountProps, CustomCountHandler {}

class CustomCount extends Component<OwnProps, any> {
  constructor(props: OwnProps) {
    super(props);
    this.state = {};
  }

  //TODO 仮実装
  getTooltipTitleLine(str: string): NonNullable<React.ReactNode> {
    return (
      <>
        {str}
        <br />
      </>
    );
  }

  // TODO 現状使っていないため、コメント化
  // getTooltipTitle(condi: filterConditionState): NonNullable<React.ReactNode>[] {
  //   const filter = this.getFilterCondition();
  //   let res: NonNullable<React.ReactNode>[] = [];
  //   res.push(this.getTooltipTitleLine(condi.filterTitle));

  //   for (let condition in filter.searchConditions) {
  //     const conditionItem: ConditionItem = {
  //       branchConditionName: condition,
  //       specifiedCondition: filter.searchConditions[condition],
  //     };
  //     res.push(this.getTooltipTitleLine(makeSearchConditionDisplayStr(conditionItem)));
  //   }
  //   return res;
  // }

  getFilterCondition(): filterConditionState {
    const key = this.props.filterKey;
    const filter = this.props.filterList.find((filter) => filter.filterKey === key);

    return filter
      ? filter
      : {
          filterKey: key,
          filterTitle: '',
          searchConditions: [],
        };
  }

  render() {
    const total = Number(this.props.countNum.doing) + Number(this.props.countNum.pending) + Number(this.props.countNum.done);

    return (
      <div className='uc-grid__col uc-grid__col--3 uc-grid__col--m4 uc-grid__col--s12 u-mb16' data-testid-e2e='customCount-card'>
        <div className='uc-card'>
          <div className='uc-card__header'>
            <h4 className='uc-card__header-title headline-5'>{this.getFilterCondition().filterTitle}</h4>
            {/* <Tooltip arrow placement='top' title={this.getTooltipTitle(this.getFilterCondition())} data-testid="tooltip">
              <Icon className='u-mh4 u-text-middle u-icon-s u-text-2l' data-testid-e2e="customCount-info">info</Icon>
            </Tooltip> */}
            <div className='uc-card__header-right'>
              <IconButton className='u-mrn8' icon='more_vert' size='s' />
            </div>
          </div>
          <div className='uc-card__content u-pb4'>
            <CustomCountTable
              total={total}
              doing={this.props.countNum.doing}
              pendinng={this.props.countNum.pending}
              done={this.props.countNum.done}
              jobDateTime={this.props.jobDateTime}
              filterConditions={this.getFilterCondition()}
              gaSpotEvent={this.props.gaSpotEvent}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CustomCount;
